$(document).on('click', '.gallery-slider-box__header .tabs__item', function(){
        $(this).closest('.gallery-slider-box').find('.gallery-slider').slick('refresh');
});